module.exports = __webpack_public_path__ + "b-green.svg?39898cbc5ec0d4d5b3346b4b4e136eee";